define('services/loading',[
    // libs
    'underscore', 'backbone', 'utils',
    'services/progress',
    // src
    'src/queue/promise-queue'
], function(
    _, Backbone, U,
    Progress,
    PromiseQueue
) {

    var queue = new PromiseQueue();

    var LoadingService = Backbone.Model.extend({
        defaults: {
            loading: false,
            syncing: false,
        },
        initialize: function() {
            this._debounceToggle = _.debounce(this.toggle.bind(this), 250);
            this._promiseErrorToggle = _.debounce(this._promiseError.bind(this), 2000);

            this.listenTo(queue, {
                'complete': this.onSyncingComplete,
                'progress': this.onSyncingProgress
            });
        },
        toggle: function(value, options) {
            value = _.isUndefined(value) ? !this.isLoading() : value;
            if (!value) Progress.done();
            return this.set({
                loading: value
            }, options);
        },

        isEnabled: function() {
            return this.get('loading');
        },

        _promiseError: function() {
            if (queue.count() === 0) return;
            U.warn('An error in the app prevented all promises from being resolved or rejected. Removing the loading screen to let the app available.');
            queue.reset();
            this.toggle(false);
        },

        startSync: function() {
            this.set({ syncing: true });
            Progress.inc();
            this._promiseErrorToggle();
        },

        ////////////
        // events //
        ////////////
        onSyncingComplete: function() {
            this.set({ syncing: false });
            this._debounceToggle(false);
        },
        onSyncingProgress: function(promise) {
            this._promiseErrorToggle();
        },
    });

    var Loading = new LoadingService();

    /**
     * Queues the promises to enable and disable loading.
     */
    Backbone.sync = (function(syncFn) {
        return function(method, model, options) {
            var promise = syncFn.call(this, method, model, options);
            Loading.startSync();
            queue.push(promise);
            return promise;
        };
    })(Backbone.sync);

    return Loading;
});

